module.exports = __webpack_public_path__ + "static/media/team.075a4508.svg";